<template>
    <div class="mapController" >
        <z-home-map ref="map"
                    :data="data"
                    @showTrack="showTrack"
                    @closeDetailPanel="closeDetailPanel"
                    @resetSelectedKey="resetSelectedKey"
                    @setSelectedRowKey="setSelectedRowKey"
                    @showDetail="showDetail">
        </z-home-map>
        <z-side-bar :collapseData="orgTreeData"
                    :filteredEntitysData="filteredEntitysData"
                    :dataOnline="filterDataOnline"
                    :dataOffline="filterDataOffline"
                    :dataAlarm="filterDataAlarm"
                    :groups="groups"
                    :total="data.length"
                    ref="sideBar"
                    @changeIsExpand="changeIsExpand"
                    @changeLength="changeLength"
                    @showInfo="onShowInfo"
                    @showTileLayer="onShowTileLayer"
                    @treeData="onTreeData"
                    @groupChange="onGroupChange"
                    @doSearch="doSearch"
                    @searchChange="onSearchChange"
                    @orgChange="onOrgChange"></z-side-bar>
        <z-map-detail :titles="titles" ref="mapDetail"></z-map-detail>
        <z-personal-track ref="personalTrackModal"></z-personal-track>
    </div>
</template>

<script>
    import config from '@/config'
    import ZHomeMap from '@/views/home/Map.vue'
    import ZSideBar from '@/views/home/SideBar.vue'
    import ZMapDetail from '@/views/home/Details.vue'
    import ZPersonalTrack from '@/views/supervise/PersonalTrack.vue'
    import bus from '../../bus/bus'
    import {mapState, mapActions, mapMutations} from 'vuex' 

    export default {
        data() {
            return {
                // 当前用户所处的机构树
                orgTree: [],
                // 组合之后的机构树数据
                orgTreeData: [],
                // 搜索时筛选后的机构树
                filteredOrgTree: [],
                // 搜索时筛选后的实体数组
                filteredEntitysData: [],
                refreshInterval:5,
                updateTimestamp: 0,
                data: [],
                dataOnline: [],
                dataOffline: [],
                dataAlarm:[],
                filterData: [],
                filterDataOnline: [],
                filterDataOffline: [],
                filterDataAlarm: [],
                groups: [],
                timer: null,
                titles: [],
                filterOption:{
                    orgLink: null,
                    group: null,
                    search: null
                },
                sceneTreeData: [],
                currentScene: {},
            }
        },
        computed: {
          ...mapState(['openedInfoBoxId'])
        },
        beforeDestroy () {
            clearInterval(this.timer);
            this.timer = null;
            bus.$off('openEntityInfo')
            // bus.$off('routeChange')
        },
        methods: {
          ...mapActions(['changedInfoBox']),
          ...mapMutations(['setOrgTreeData']),
            // 获取机构树
            getOrgTree () {
                return new Promise((resolve) => {
                    this.$http.get(config.api.org_tree_url).then((res) => {
                        if (res.code === 0) {
                            this.orgTree = [res.result]
                            // console.log(this.orgTree)
                            let topOrgLevel = this.orgTree[0].level
                            // console.log(topOrgLevel)
                            this.initTreeDefaultProp(this.orgTree,topOrgLevel)
                            resolve()
                        }
                    })
                })
            },
            initTreeDefaultProp(tree,topOrgLevel){
                if(tree){
                    tree.map(item => {
                        item.is_expand = item.level > topOrgLevel  ? false : true
                        item.length = 5
                        // console.log(item)
                        this.initTreeDefaultProp(item.children, topOrgLevel)
                    })
                }
            },
            changeIsExpand(orgId,isExpand){
              let node = this.getNodeById(orgId,this.orgTree)
              if(node != null){
                node.is_expand = isExpand
                // console.log(isExpand)
                // console.log(this.orgTreeData)
                // 此处可以考虑一下地图是否切换到当前机构的实体范围
              }
              // 如果当前是展开的话，需要设置同级别的其余为关闭
              // if (isExpand) {
              //   let sameLevelNodes = this.getSameLevelNodes(orgId,this.orgTree)
              //   console.log(sameLevelNodes)
              //   sameLevelNodes.filter((node) => node.id != orgId).forEach((node) => {
              //     node.is_expand = false
              //     node.isExpand = false
              //   })
              // }
            },
            changeLength(orgId,length){
                let node = this.getNodeById(orgId,this.orgTree)
                if(node != null){
                    node.length = length
                }
            },
            getNodeById(nodeId,data){
                for(let i = 0 ; i < data.length ; i ++){
                    if(nodeId == data[i].id){
                        return data[i]
                    }

                    if(data[i].children){
                        let node =  this.getNodeById(nodeId,data[i].children);
                        if(node){
                            return node
                        }
                    }
                }
                return null;
            },
            getSameLevelNodes (nodeId, data) {
              for(let i = 0 ; i < data.length ; i ++){
                  if(nodeId == data[i].id){
                      return data
                  }

                  if(data[i].children){
                      let node =  this.getSameLevelNodes(nodeId,data[i].children);
                      if(node){
                          return node
                      }
                  }
              }
              return null;
            },
            sortEntitys (entitys) {
                // 按是否绑表排序
                entitys.sort((a, b) => {
                    if (a.deviceId && !b.deviceId) {
                        return -1
                    }
                    if (!a.deviceId && b.deviceId) {
                        return 1
                    }
                    if ((a.deviceId && b.deviceId) || (!a.deviceId && !b.deviceId)) {
                        return 0
                    }
                })
                // 再按是否在线排序
                entitys.sort((a, b) => {
                    if (a.onlineStatus && !b.onlineStatus) {
                        return -1
                    }
                    if (!a.onlineStatus && b.onlineStatus) {
                        return 1
                    }
                    if ((a.onlineStatus && b.onlineStatus) || (!a.onlineStatus && !b.onlineStatus)) {
                        return 0
                    }
                })
                return entitys
            },
            // 将机构树和人员信息合并
            mergeOrgAndEntity (orgs=[], entitysData=[]) {
              // console.log(orgs)
                let orgTreeData = orgs.map((org) => {
                    // console.log(org)
                    // 从所有该机构下的实体中找出与该机构link一致的实体
                    let entitys = entitysData.filter((entity) => org.link === entity.org_link)
                    // 将entitys进行排序
                    entitys = this.sortEntitys(entitys)
                    // console.log(entitys)
                    // 当前机构含有下级机构
                    if (org.hasOwnProperty('children') && org.children.length > 0) {
                        this.mergeOrgAndEntity(org.children, entitysData)
                        return {
                            name: org.name,
                            entitys,
                            length: org.length,
                            link: org.link,
                            is_expand: org.is_expand,
                            id: org.id,
                            pid:org.pid,
                            children: this.mergeOrgAndEntity(org.children, entitysData)
                        }
                    } else {
                        // 该机构没有下级机构
                        return {
                            is_expand: org.is_expand,
                            name: org.name,
                            pid:org.pid,
                            length: org.length,
                            entitys,
                            link: org.link,
                            id: org.id,
                        }
                    }
                })
                return orgTreeData
            },
            setSelectedRowKey(key){
                this.$refs["sideBar"].setSelectedRowKey(key)
            },
            resetSelectedKey(){
                this.$refs["sideBar"].resetSelectedKey()
            },
            closeDetailPanel(){
                this.$refs["mapDetail"].closeDetail()
            },
            onShowInfo(info){
              console.log("Home onShowInfo",info);
                this.$refs["map"].showInfo(info)
            },
            onShowTileLayer(info) {
                console.log("Home onShowTileLayer", info);
                this.$nextTick(() => {
                    this.$refs["map"].showTileLayer(info)
                })
            },
            onTreeData(data) {
                console.log("Home onTreeData",data);
                this.$nextTick(() => {
                    this.$refs["map"].getTreeData(data)
                })
            },
            queryEntityTitles(){
                this.$http.get(config.api.entity_title_url).then((response) => {
                    if (response.code == 0) {
                        this.titles = response.result
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            showDetail(info,type){
                this.$refs["mapDetail"].showDetail(info,type)
            },
            showTrack(info){
                bus.$emit('showMapTrack')
                let record = {}
                record = info
                record.姓名 = info.entity
                record.group = info.group
                record.org = info.org
                record.key = info.id
                this.$refs['personalTrackModal'].showModal(record)
            },
            onGroupChange(group){
                this.filterOption.group = group ? group : null
                this.doFilter()
            },
            // 选择机构
            onOrgChange(org){
                // 每一次查询前都要重新合并数据，以保证实体数据时齐全的
                // this.orgTreeData = this.mergeOrgAndEntity(this.orgTree)
                // console.log(org.link)
                let link = org
                let orgs = this.orgTree
                // 最外层是否找到需要的Link
                // 遍历orgtree 找出对应link的位置
                //
                let newData = this.orgFind(link, orgs)
                if (!newData) {
                    this.loopOrgs(orgs, link)
                } else {
                    // 即查找的是最外侧
                    this.filteredOrgTree = [ newData ]
                }
            },
            loopOrgs (orgs, link) {
                orgs.forEach((org) => {
                    if (org.hasOwnProperty('children') && org.children.length > 0) {
                        let curData = this.orgFind(link, org.children)
                        if (!curData) {
                            this.loopOrgs(org.children, link)
                        } else {
                            this.filteredOrgTree = [ curData ]
                            // console.log(this.orgTreeData)
                        }
                    }
                })
            },
            orgFind (link='', orgs=[]) {
                return orgs.find((org) => org.link == link)
            },
            splitOrgLink (orgLink) {
              let linkArr = orgLink.split(',')
              linkArr.pop()
              // console.log(linkArr)
              return linkArr
            },
            // 搜索时
            onSearchChange(search, type, orgLink){
              // this.splitOrgLink(orgLink)
              // console.log(this.data)
              let allData = this.data.filter((entity) => {
                let orgLinkArr = this.splitOrgLink(orgLink)
                let index = orgLinkArr.length - 1
                let value = orgLinkArr[index]
                let entityLinkArr = this.splitOrgLink(entity.org_link)
                return entityLinkArr[index] === value
              })
              // console.log(allData)
              // console.log(allData)
              // console.log(type)
              // 首先判断搜索类型 绑定状态
              if (type.bindStatu !== 'all') {
                let bindTypes = new Map()
                bindTypes.set('bind', allData.filter((item) => item.deviceId))
                bindTypes.set('unbind', allData.filter((item) => !item.deviceId))
                allData = bindTypes.get(type.bindStatu)
                // console.log(allData)
              }
              // 首先判断搜索类型 其它类型搜索
              if (type.customType !== 'all') {
                let customTypes = new Map()
                customTypes.set('online', allData.filter((item) => item.onlineStatus === true))
                customTypes.set('offline', allData.filter((item) => item.onlineStatus === false))
                customTypes.set('alarm', allData.filter((item) => item.alarmNum > 0))
                allData = customTypes.get(type.customType)
                // console.log(allData)
              }
              // 判断search
              if (search) {
                this.filteredEntitysData = allData.filter(item => item.entity.indexOf(search) != -1 || (item.sn && item.sn.indexOf(search) != -1) || (item.extra && item.extra.indexOf(search) != -1))
              } else {
                this.filteredEntitysData = allData
              }
              
              // console.log(search)
              // 1.将符合条件的实体筛选出来
              
            },
        
            // 搜索应该可以同时多条件
            doSearch (param) {
                // console.log(param)
                // 思路： 搜索时
                // 根据org参数先找出orgTree当中对应的tree
                if (param.org) {
                    this.onOrgChange(param.org)
                } else {
                    // 如果org参数为空，则等于原始数据
                    this.filteredOrgTree = this.orgTree
                }
                // 根据search找出对应的 entitys data
                this.onSearchChange(param.search, param.type, param.org)
                // 将2个数据组合起来
                this.orgTreeData = this.mergeOrgAndEntity(this.filteredOrgTree, this.filteredEntitysData)
                // console.log(this.orgTreeData)
            },

            getGroups(){
                this.$http.get(config.api.entity_group_url).then((response) => {
                    if(response.code == 0){
                        let _this = this
                        response.result.map(function(item){
                            _this.groups.push({"name":item.name,"category":item.category})
                        })
                        // console.log(this.groups)
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            loadData(){
                return new Promise((resolve) => {
                    this.$http.get(config.api.entity_map_data_url + '?timestamp=' + this.updateTimestamp).then((response) => {
                        if(response.code == 0){
                            this.refresh(response.result)
                            this.updateTimestamp = response.result.timestamp
                            resolve()
                        }
                    })
                })
            },
            loadDataPeriod(){
                // this.loadData()
                this.timer = setInterval(this.loadData, this.refreshInterval*1000)
            },
            hasUpdataDataWithSameId (updateData=[], id) {
              if (updateData.length > 0) {
                return updateData.some((item) => item.id === id)
              } else {
                return false
              }
            },
            refresh(response){
                // console.log(response)
                if(response.type == "all"){
                    this.data = response.data
                    // console.log(this.data)
                    this.filterData = response.data
                    this.filteredEntitysData = this.sortEntitys(response.data)
                    this.$refs['map'].refreshAll(this.data)
                }else if(response.type == "update"){
                    // console.log(response)
                    this.dataMerge(response.data.addData,"add")
                    this.dataMerge(response.data.deleteData,"delete")
                    this.dataMerge(response.data.updateData,"update")
                    // this.$refs['map'].updateScene(response.data)
                    // 这里会在每次更新数据的时候进行一次搜索，虽损失一些性能，但可以保证数据是最实时的
                    // 若不进行一次搜索，可以保证数据时实时的，但若用户此前有搜索行为且未清除搜索参数，则会导致用户的所搜索失效
                    // 若既要保证用户搜索不失效，又能保证数据最新，则会导致数据第一次更新时所有人员消失的情况。
                    this.$refs["sideBar"].onSearch()
                    // if () {}
                    this.orgTreeData = this.mergeOrgAndEntity(this.filteredOrgTree, this.filteredEntitysData)
                    // 将机构人员树存入vuex
                    this.setOrgTreeData(this.orgTreeData)
                    // 如果目前有打开的infoBox
                    // console.log('目前有打开的infoBoxId:', this.openedInfoBoxId)
                    if (this.openedInfoBoxId) {
                      // 在更新的数据中含有目前打开的infobox展示的数据，就更新infobox
                      if (this.hasUpdataDataWithSameId(response.data.updateData, this.openedInfoBoxId)) {
                        // this.$refs['infobox']
                        let info = this.data.find((item) => item.id === this.openedInfoBoxId)
                        // console.log(info)
                        // this.onShowInfo(info)
                        this.changedInfoBox(info).then(() => {
                          // bus.$emit('freshInfoBox')
                          this.$refs['map'].$refs['infoBox'].freshInfoBox()
                        })
                      }

                      //室内地图打开
                    //   response.data.updateData.find(item => {
                    //     if(item.id === this.openedInfoBoxId && item.loc_type == 'bluetooth') { 
                    //             this.onTreeData(this.sceneTreeData)
                    //             this.onShowTileLayer(this.currentScene)
                    //     }else{
                    //         //移除室内地图
                    //         this.$refs['map'].cancelModal()
                    //     }
                    //   })
                    }
                }

            },

            findDataById(data, targetId) {
                if (data.data && data.data.id === targetId) {
                    return data.data;  
                }
                
                if (data.children && Array.isArray(data.children)) {
                    for (let child of data.children) {
                        const found = this.findDataById(child, targetId);
                        if (found) {
                            return found;
                        }
                    }
                }
                
                return null;
            },
       
            dataMerge(data,type){
                let _this = this
                if(type == 'add'){
                    data.map(function(item){
                        var isExist = false
                        for(var i = 0 ; i < _this.data.length ; i ++){
                            if(_this.data[i].id == item.id ){
                                isExist = true
                            }
                        }
                        if(!isExist){
                            _this.data.push(item)
                            if(item.lat && item.lng){
                                _this.$refs["map"].addMarker(item)
                            }
                        }
                    })
                }else if(type == 'update'){
                    for(var i = 0 ; i < this.data.length ; i ++){
                        data.map(function(item){
                            if(_this.data[i].id == item.id ){
                                _this.data[i] = item
                                if(!item.lat || !item.lng){
                                    _this.$refs["map"].deleteMarker(item)
                                }else{
                                    _this.$refs["map"].setMarker(item)
                                }
                            }
                        })
                    }
                }else if(type == 'delete'){
                    let _this = this
                    data.map(function(item){
                        _this.data = _this.data.filter(subItem => subItem.id != item)
                        _this.$refs["map"].deleteMarker(item)
                    })
                }
                // this.$refs['map'].refreshAll(this.data)
            },
            showAlarm () {
              let info = this.data.find((entity) => entity.id == this.$route.query.id)
              this.onShowInfo(info)
              this.showDetail(info, 'alarm')
            },
            onUserClick () {
              // console.log(this.$route)
              // console.log(this.data)
              if (this.$route.query.id) {
                if (this.data.length > 0) {
                  this.showAlarm()
                } else {
                  setTimeout(this.onUserClick, 2000)
                }
              }
            },
            // 处理点击人员自动打开室内地图
            handleOpenIndoorMap(item) {
              console.log("Home handleOpenIndoorMap", item);
              // 获取场景围栏数据
              this.$http.get(config.api.org_tree_url).then((response) => {
                if (response.code == 0) {
                  // console.log("org_tree_url response", response);
                  // 获取场景详情
                  this.$http.get(config.api.get_scenes_fence + response.result.scenes).then((res) => {
                    if (res.code === 0) {
                      console.log("get_scenes_fence response", res); 
                      this.sceneTreeData = res.result
                      this.onTreeData(this.sceneTreeData)
                      // 查找对应场景
                      let scene = this.findDataById(res.result[0], item.scene);
                      if(scene && item.loc_type === 'bluetooth') {
                        this.currentScene = scene
                        // 打开室内地图
                        this.onShowTileLayer(this.currentScene);
                      }else{
                         this.$refs['map'].cancelModal()
                      }
                    }
                  }).catch((err) => {
                    console.log("get_scenes_fence error", err);
                  });
                }
              }).catch((err) => {
                console.log("org_tree_url error", err);
              });
            }
        },
        components:{
            ZSideBar,
            ZHomeMap,
            ZMapDetail,
            ZPersonalTrack
        },
        created () {
            // 获取实体数据和获取机构数据均是异步请求
            // 将机构和实体数据组合需在两者同时完成后才能开始
            Promise.all([this.loadData(), this.getOrgTree()]).then(() => {
                this.orgTreeData = this.mergeOrgAndEntity(this.orgTree, this.data)
                this.$refs["sideBar"].$refs["collapseOrg"].setSelectNodeLink(this.orgTreeData[0].link)
                // 将机构人员树存入vuex
                this.setOrgTreeData(this.orgTreeData)
            })
            this.loadDataPeriod()
        },
        mounted(){
            this.getGroups()
            this.queryEntityTitles()
            this.onUserClick()
            bus.$on('routeChange', (route) => {
              // console.log(route)
              if (route.query && route.query.id && this.$route.path == route.route) {
                this.onUserClick()
              }
            })
            // 监听来自侧边栏点击人员的打开室内地图事件
            // bus.$on('openIndoorMapFromSidebar', (item) => {
            //   this.handleOpenIndoorMap(item)
            // })
            
        }
    }
</script>

<style scoped>
    .mapController {
        width: 100%;
        position: fixed;
        height: 100%;
        padding: 0% 0% 0% 0%;
    }
</style>